import styled from 'styled-components';
import BasePitchFxXStyles from 'responsive-pitch-fx/dist/latest/responsive-pitch-fx.css';

export const PitchFxContainerWrapper = styled.div`
    font-family: var(--gameday-primary-font);
    overflow: hidden;
    vertical-align: top;
    visibility: visible;
    position: relative;
    ${BasePitchFxXStyles}
`;

export const StadiumWrapper = styled.section`
    position:relative;
    overflow:hidden;
    width: 100%;
    margin: 0 0;
    height: 100%;
    left:0;
    background-image: linear-gradient(to bottom, #7fbaff, #ffffff, #3b431a);
    &.night {
        background-image: linear-gradient(to bottom, #02060f, #484950, #3b431a);
    }
`;

export const FieldWrapper = styled.div.attrs(({
    stadiumImages
}) => {
    const topImage = stadiumImages?.top;
    const bottomImage = stadiumImages?.bottom;
    const bgUrls = topImage && bottomImage ? 'url(' + bottomImage + '), url(' + topImage + ')' : 'none';
    return {
        style: {
            transition: 'background-image 500ms linear',
            backgroundImage: bgUrls
        }
    };
})`
    width:100%;
    height:auto;
    position:relative;
    box-sizing: border-box;
    background-size: calc(100% + 1px) auto, calc(100% + 1px) auto;
    background-position : center bottom, center top;
    background-repeat : no-repeat, no-repeat;
    margin: 0 0;
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    transition: background-image 500ms linear;
    aspect-ratio: 4 / 3;

    .responsive-pitch-fx-render,
    .responsive-pitch-fx-svg,
    .responsive-pitch-fx-dom,
    .responsive-pitch-fx-player {
        margin-top: 6%;
    }

    .responsive-pitch-fx-aspect-ratio {
        width:auto;
        max-width: none;
        min-width:100%;
        height:100%;
        aspect-ratio: 4 / 3;
    }
`;

export const PitchFxWrapper = styled.section`
    font-size:1.1em;
    position:relative;
    z-index:1;
    width:100%;
    vertical-align: top;
`;
